export default __webpack_public_path__ + "img/download-new.3b8b434c.svg";